<template>
  <div
    class="card shadow position-relative"
    style="min-height:120px;"
  >
    <div
      v-if="isEditable"
      class="position-absolute cursor-pointer"
      style="right:8px; top: 8px;"
      @click="edit"
    >
      <v-icon icon="pen" />
    </div>
    <div class="card-body">
      <div class="d-flex flex-column justify-content-around h-100 text-center">
        <div class="d-flex mx-auto mb-1">
          <v-icon
            icon="umbrella"
            width="24"
            height="24"
          />
        </div>
        <div class="d-flex flex-column mt-auto mb-2">
          <div class="mx-auto">
            Franchise
          </div>
          <div class="mx-auto fw-bold">
            {{ deductible | formatPrice(true) }} €
          </div>
        </div>
        <div class="d-flex flex-column mb-auto mb-1">
          <div class="mx-auto">
            Prime annuelle TTC
          </div>
          <div class="mx-auto fw-bold">
            {{ annualPremium | formatPrice(true) }} €
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';

export default {
  name: 'ContractSmallCardDeductibleAndPremium',
  props: {
    deductible: {
      type: Number,
      required: true,
    },
    annualPremium: {
      type: Number,
      required: true,
    },
    isEditable: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters({
      contract: 'contract/get',
    }),
  },
  methods: {
    edit() {
      this.$emit('edit', 'deductible');
    },
  },
};
</script>
